import { Module } from 'vuex';
import { getters } from './getters';
import { LicenseState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: LicenseState = {
    licenses: undefined,
    count: 0,
    details: undefined,
    createResult: undefined,
    capacityInfo: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    activate: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    capacity: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    active: {
        activeInfo: undefined,
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const license: Module<LicenseState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
